import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { MedicalNoteResponse, MedicalNoteType } from './medicalNotes';

export type ClaimCorrectionNoteResponse = MedicalNoteResponse<MedicalNoteType.claimCorrectionNote>;

export const createClaimCorrectionNote = async (patientId: string) =>
  restClient.request<ClaimCorrectionNoteResponse>(`/api/v1/patient/${patientId}/medical_notes/claim_correction_note`, {
    method: 'POST',
    data: { claim_correction_note_form: {} }
  });

export const getClaimCorrectionNote = async (noteId: string) =>
  restClient.request<ClaimCorrectionNoteResponse>(`/api/v1/medical_notes/${noteId}`);


export const getMedicalNoteDetailsById = async (noteId: string) =>
  restClient.request<{
    data: {
      providerId: string;
      submittedAt: string;
      serviceDate: string;
    };
  }>(`/api/v1/medical_notes/${noteId}/details`);

export type UpdateClaimCorrectionNoteInput = {
  cptCodeIds?: string[];
  diagnosisIds?: string[];
  claimCorrectionNoteForm: Record<string, unknown>;
  isSubmitted?: boolean;
};

export const updateClaimCorrectionNote = async (noteId: string, data: UpdateClaimCorrectionNoteInput) =>
  restClient.request<ClaimCorrectionNoteResponse>(`/api/v1/medical_notes/claim_correction_note/${noteId}`, {
    method: 'PATCH',
    data: snakecaseKeys(data)
  });